<footer class="d-flex ps-4 pe-4">
  <div class="d-none d-md-block"></div>
  <img height="20" alt="logo libriciel" src="assets/libriciel_white.svg">
  <div class="text-white d-flex justify-content-end">
    <a title="Youtube - Libriciel SCOP" target="_blank" class="youtube-link"
       href="https://www.youtube.com/user/adullactprojet">
      <fa-icon class="me-3" size="lg" [icon]="faYoutube"></fa-icon>
    </a>
    <a title="LinkedIn - Libriciel SCOP" target="_blank" class="linkedin-link"
       href="https://fr.linkedin.com/company/libriciel-scop">
      <fa-icon size="lg" [icon]="faLinkedin"></fa-icon>
    </a>
  </div>
</footer>
